<template>
  <div class="transaction_list">
    <ModalDelete ref="ModalDelete" confirm-text="ya" @action="cancel">
      <template v-slot:title>
        <span class="primary--text text-capitalize font-weight-bold"
          >Batalkan Transaksi</span
        >
      </template>
      <template v-slot:body>
        <div class="text-center">
          Apakah Anda yakin untuk membatalkan transaksi "
          <span class="text-capitalize">{{ invoice_selected }}</span
          >"?
        </div>
      </template>
    </ModalDelete>
    <ModalDelete
      ref="ModalReceive"
      confirm-text="ya"
      confirm-color="primary"
      @action="receive"
    >
      <template v-slot:title>
        <span class="primary--text text-capitalize font-weight-bold"
          >konfirmasi penerimaan</span
        >
      </template>
      <template v-slot:body>
        <div class="text-center">
          Apakah Anda yakin sudah menerima transaksi ini?
        </div>
      </template>
    </ModalDelete>
    <v-col class="pt-5">
      <div>
        <v-row>
          <v-col cols="12" md="3" class="py-0 pr-md-0">
            <profile-menu></profile-menu>
          </v-col>
          <v-col cols="12" md="9" class="pl-md-5 py-0 mt-5 mt-md-0">
            <section-filter @cari="cari" @reset="resetFilter">
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-text-field
                    v-model="invoiceFilter.value"
                    outlined
                    small
                    dense
                    hide-details
                    class="searchInput"
                    placeholder="Cari Transaksi"
                  >
                    <div slot="append">
                      <v-btn small elevation="2" color="success">
                        <v-icon center>mdi-magnify</v-icon>
                      </v-btn>
                    </div>
                  </v-text-field>
                </v-col>

              <v-col cols="6" class="py-0">
                <v-select
                  v-model="statusFilter.value"
                  :items="statusList"
                  item-text="label"
                  item-value="value"
                  placeholder="Pilih Status"
                  outlined

                  dense
                ></v-select>
              </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" class="py-0">
                  <v-menu bottom offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="dateUpload" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                        v-on="on" hide-details="auto" outlined clearable densed class="datePickerSmall"
                        placeholder="Tanggal Upload" @click:clear="clearDate"></v-text-field>
                    </template>
                    <v-date-picker v-model="date" range no-title></v-date-picker>
                  </v-menu>

                </v-col>
                <v-col cols="12" sm="4" class="py-0">
                  <v-menu bottom offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="dateApproval" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                        v-on="on" hide-details="auto" outlined clearable densed class="datePickerSmall"
                        placeholder="Tanggal Approval" @click:clear="clearDateApproval"></v-text-field>
                    </template>
                    <v-date-picker v-model="dateApprovalRange" range no-title></v-date-picker>
                  </v-menu>

                </v-col>
                <!-- <v-col cols="12" sm="4" class="py-0">
                  <v-menu bottom offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="dateJatuhTempo" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                        v-on="on" hide-details="auto" outlined clearable densed class="datePickerSmall"
                        placeholder="Tanggal Jatuh Tempo" @click:clear="clearDateJatuhTempo"></v-text-field>
                    </template>
                    <v-date-picker v-model="dateJatuhTempoRange" range no-title></v-date-picker>
                  </v-menu>

                </v-col> -->
              </v-row>
            </section-filter>
            <div
              v-if="
                historyUploadTerminData.length == 0 &&
                !historyUploadTerminPagination
              "
            >
              <div class="pb-4">
                <v-card outlined elevation="0" class="py-3 rounded-lg">
                  <v-col class="pb-0">
                    <vcl :width="300" :height="65">
                      <rect x="0" y="0" rx="2" ry="2" width="60" height="5" />
                      <rect x="260" y="0" rx="2" ry="2" width="40" height="5" />
                      <rect x="5" y="15" rx="2" ry="2" width="80" height="5" />
                      <rect x="5" y="25" rx="2" ry="2" width="95" height="5" />
                      <rect
                        x="5"
                        y="35"
                        rx="2"
                        ry="2"
                        width="155"
                        height="10"
                      />
                      <rect x="5" y="50" rx="2" ry="2" width="45" height="5" />
                      <rect x="70" y="50" rx="2" ry="2" width="45" height="5" />
                      <rect x="5" y="60" rx="2" ry="2" width="45" height="5" />
                      <rect x="70" y="60" rx="2" ry="2" width="45" height="5" />
                      <rect
                        x="240"
                        y="18"
                        rx="2"
                        ry="2"
                        width="35"
                        height="12"
                      />
                      <rect
                        x="220"
                        y="34"
                        rx="2"
                        ry="2"
                        width="75"
                        height="12"
                      />
                      <rect
                        x="220"
                        y="50"
                        rx="2"
                        ry="2"
                        width="75"
                        height="12"
                      />
                    </vcl>
                  </v-col>
                </v-card>
              </div>
            </div>
            <div
              v-else-if="
                historyUploadTerminData.length == 0 && transactionPagination
              "
            >
              <v-card outlined elevation="0" class="py-3 rounded-lg">
                <v-row class="justify-center">
                  <v-col cols="7" md="5">
                    <v-img
                      width="100%"
                      src="/assets/icons/belum-ada-pesanan.svg"
                    ></v-img>
                  </v-col>
                </v-row>
                <div class="text-center pb-3">
                  <div class="pt-1 text-body-1 font-weight-bold">
                    Belum ada pesanan
                  </div>
                </div>
              </v-card>
            </div>
            <div v-else>
              <div
                class="pb-4"
                v-for="data in historyUploadTerminData"
                :key="data.id"
              >
                <v-card outlined elevation="0" class="py-3 rounded-lg">
                  <v-row class="px-3">
                    <v-col class="py-1 text-body-2 my-auto">
                      <div class="d-block d-md-flex font-weight-bold">
                        <div>Transaksi</div>
                        <div class="pt-1 pt-md-0 pl-md-1">
                          {{ data.trx_code }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <div class="px-3 py-2">
                    <v-divider></v-divider>
                  </div>
                  <v-row class="pl-3 pl-md-5 pr-3">
                    <v-col
                      cols="12"
                      sm="7"
                      md="12"
                      class="pl-3 pl-md-5 py-0 text-body-2"
                    >
                      <div class="pt-3 d-md-flex">
                        <div class="pt-1 pt-md-0 d-flex">
                          <div
                            class="pl-md-3 font-size-13 grey--text text--darken-1"
                          >
                            Waktu Bayar:
                          </div>
                          <div class="pl-3 text-body-2 font-weight-bold">
                            {{ data.create_datetime | tanggaljam }}
                          </div>
                        </div>
                      </div>
                      <div
                          v-if="data.update_datetime"
                          class="pt-1 pt-md-0 d-flex"
                        >
                          <div
                            class="pl-md-3 font-size-13 grey--text text--darken-1"
                          >
                            Waktu Diapprove:
                          </div>
                          <div class="pl-3 text-body-2 font-weight-bold">
                            {{ data.update_datetime | tanggaljam }}
                          </div>
                        </div>
                      <StatusTransaction
                        :status="'payment_'+data.status"
                      ></StatusTransaction>
                      <div class="pt-3 d-md-flex">
                        <div class="d-flex">
                          <div class="font-size-13 grey--text text--darken-1">
                            Total Tagihan:
                          </div>
                          <div
                            class="pl-3 text-body-2 red--text font-weight-bold"
                          >
                            {{  data.status == 'approved' ? data.finance_total_remaining_debt_before : data.total_remaining_debt  | toRupiah }}
                          </div>
                        </div>
                        <div class="pt-1 pt-md-0 d-flex ml-3">
                          <div class="font-size-13 grey--text text--darken-1">
                            Total Bayar:
                          </div>
                          <div class="pl-3 text-body-2 font-weight-bold">
                            {{ data.finance_amount | toRupiah }}
                          </div>
                        </div>
                        <div class="pt-1 pt-md-0 d-flex">
                          <div
                            class="pl-md-3 font-size-13 grey--text text--darken-1"
                          >
                            Sisa Tagihan :
                          </div>
                          <div
                            class="pl-3 text-body-2 red--text font-weight-bold"
                          >
                            {{ data.finance_total_remaining_debt_after | toRupiah }}
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="5"
                      md="4"
                      class="text-center text-md-right"
                    > 
                    </v-col>
                  </v-row>
                </v-card>
              </div>
              <v-row
                class="pt-4 justify-center"
                v-if="historyUploadTerminPagination.total_page > 1"
              >
                <v-pagination
                  v-model="page"
                  @input="changePage"
                  :length="historyUploadTerminPagination.total_page"
                  class="elevation-0"
                ></v-pagination>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ProfileMenu from "@/components/layout/store/ProfileMenu";
import StatusTransaction from "@/components/StatusTransaction";
import ModalDelete from "@/components/ModalDelete";

import sectionFilter from "../../../components/sectionFilter.vue";
import moment from "moment";
export default {
  components: {
    ProfileMenu,
    sectionFilter,
    StatusTransaction,
    ModalDelete,
  },
  data() {
    return {
      statusList:[
      {
        label: "Semua Status",
        value: "",
      },
      {
        label: "Menunggu Verifikasi",
        value: "pending",
      },
      {
        label: "Pembayaran Disetujui",
        value: "approved",
      },
      {
        label: "Pembayaran Ditolak",
        value: "rejected",
      },
      ],
      page: 1,
      filterOptions: [
        {
          label: "No. Invoice",
          value: "invoice",
        },
        {
          label: "Nama Pembeli",
          value: "buyer",
        },
      ],
      isMobile: false,
      menuDate: false,
      filter: {
        type: {
          label: "No. Invoice",
          value: "invoice",
        },
        search: "",
        filterId: null,
        sortId: null,
        dateRange: null,
      },
      limit: 5,
      homepage: process.env.VUE_APP_HOMEPAGE,
      params: [
        {
          value: "1",
          comparison: "=",
          type: "string",
          field: "is_top",
        },
      ],
      sortBy: "",
      sortDir: "DESC",
      invoice_selected: "",
      tempoFilter: {
        value: "1",
        comparison: "=",
        type: "string",
        field: "is_top",
      },
      invoiceFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "trx.trx_code",
      },
      statusFilter: {
        value: "",
        comparison: "=",
        type: "string",
        field: "payment_detail.status",
      },
      date: [],
      periodTempoCreated: {
        value: '',
        comparison: 'bet',
        type: 'date',
        field: 'payment_detail.create_datetime',
      }, 
      dateApprovalRange: [],
      periodApproval: {
        value: '',
        comparison: 'bet',
        type: 'date',
        field: 'payment_detail.update_datetime',
      },
      dateJatuhTempoRange: [],
      periodJatuhTempo: {
        value: '',
        comparison: 'bet',
        type: 'date',
        field: 'trx.termin_date',
      },
    };
  },
  computed: {
    dateUpload() {
      return this.date.join(' ~ ')
    },
    dateApproval() {
      return this.dateApprovalRange.join(' ~ ')
    },
   dateJatuhTempo() {
      return this.dateJatuhTempoRange.join(' ~ ')
    },
    dateRangeText: {
      get() {
        let dates = this.filter.dateRange
          ? new Date(this.filter.dateRange)
          : null;
        return dates ? moment(dates).format("DD MMM YYYY") : null;
      },
      set() {
        let dates = this.filter.dateRange
          ? new Date(this.filter.dateRange)
          : null;
        return dates ? moment(dates).format("DD MMM YYYY") : null;
      },
    },
    ...mapState("transaction", [
      "loadTransaction",
      "historyUploadTerminData",
      "historyUploadTerminPagination",
      "transactionPagination",
    ]),
  },
  methods: {
    resetFilter() {
      this.invoiceFilter.value = "";
      this.tempoFilter.value = "";
      this.statusFilter.value = "";
      this.date = []
      this.dateApprovalRange = []
      this.dateJatuhTempoRange = []
      this.periodApproval.value = ''
      this.periodTempoCreated.value = ''
      this.periodJatuhTempo.value = ''
      this.cari();
    },
    cari() {
      this.params = [];

      if (this.invoiceFilter.value) this.params.push(this.invoiceFilter);
      if (this.statusFilter.value) this.params.push(this.statusFilter);
      if(this.date.length > 0){
      if (this.date.length == 1) {
        this.periodTempoCreated.value =this.createFilterDate(this.date[0],this.date[0]) 
      } else if (this.date.length == 2) {
        this.periodTempoCreated.value = this.createFilterDate(this.date[0],this.date[1]) 
      }
     }
     if(this.dateApprovalRange.length > 0){
       if (this.dateApprovalRange.length == 1) {
         this.periodApproval.value =this.createFilterDate(this.dateApprovalRange[0],this.dateApprovalRange[0]) 
        } else if (this.dateApprovalRange.length == 2) {
          this.periodApproval.value =this.createFilterDate(this.dateApprovalRange[0],this.dateApprovalRange[1])  
        }
      }
     if(this.dateJatuhTempoRange.length > 0){
       if (this.dateJatuhTempoRange.length == 1) {
         this.periodJatuhTempo.value =this.createFilterDate(this.dateJatuhTempoRange[0],this.dateJatuhTempoRange[0]) 
        } else if (this.dateJatuhTempoRange.length == 2) {
          this.periodJatuhTempo.value =this.createFilterDate(this.dateJatuhTempoRange[0],this.dateJatuhTempoRange[1])  
        }
      }
      if (this.periodTempoCreated.value !== "") {
        this.params.push(this.periodTempoCreated);
      }
      if (this.periodJatuhTempo.value !== "") {
        this.params.push(this.periodJatuhTempo);
      }
      if (this.periodApproval.value !== "") {
        this.params.push(this.periodApproval);
      }
      this.sortBy = this.sortBy;
      this.sortDir = this.sortDir;
      this.page = 1;
      this.historyUploadTermin(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir,
        })
      );
    },
    createFilterDate(date1,date2){
      return  moment(date1).format("YYYY-MM-DD") +"::" +moment(date2).format("YYYY-MM-DD");
    },
    async clearDate() {
      this.date = await [];
      this.periodTempoCreated.value = await '';
      // this.searchTrx();
    },
    async clearDateApproval() {
      this.dateApprovalRange = await [];
      this.periodApproval.value = await '';
      // this.searchTrx();
    },
    async clearDateJatuhTempo() {
      this.dateJatuhTempoRange = await [];
      this.periodJatuhTempo.value = await '';
      // this.searchTrx();
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    ...mapActions("transaction", [
      "historyUploadTermin",
      "cancelTransaction",
      "receiveTransaction",
      "cancelBank",
      "cancelStore",
      "cancelVA",
    ]),

    showModalDelete(invoice, type) {
      this.invoice_selected = invoice;
      this.type_payment = type;
      this.$refs.ModalDelete.modalShow();
    },
    cancel() {
      if (this.type_payment == "midtrans") {
        this.cancelTransaction({ invoice: this.invoice_selected }).then(() => {
          this.historyUploadTermin(
            this.queryString({
              limit: this.limit,
              page: this.page,
              params: this.params,
              sort: this.sortBy,
              dir: this.sortDir,
            })
          );
        });
      } else if (this.type_payment == "bank_transfer") {
        this.cancelBank({ invoice: this.invoice_selected }).then(() => {
          this.historyUploadTermin(
            this.queryString({
              limit: this.limit,
              page: this.page,
              params: this.params,
              sort: this.sortBy,
              dir: this.sortDir,
            })
          );
        });
      } else if (this.type_payment == "payment_store") {
        this.cancelStore({ invoice: this.invoice_selected }).then(() => {
          this.historyUploadTermin(
            this.queryString({
              limit: this.limit,
              page: this.page,
              params: this.params,
              sort: this.sortBy,
              dir: this.sortDir,
            })
          );
        });
      } else if (this.type_payment == "va") {
        this.cancelVA({ invoice: this.invoice_selected }).then(() => {
          this.historyUploadTermin(
            this.queryString({
              limit: this.limit,
              page: this.page,
              params: this.params,
              sort: this.sortBy,
              dir: this.sortDir,
            })
          );
        });
      }
    },
    downloadPDF(pdf) {
      window.open(pdf);
    },
    confirmReceived(id) {
      this.invoice_selected = id;
      this.$refs.ModalReceive.modalShow();
    },
    async clearSearch() {
      this.filter.search = await "";
      this.filter.type = await {
        label: "No. Invoice",
        value: "invoice",
      };
      this.buyerNameFilter.value = await "";
      this.invoiceNoFilter.value = await "";
    },

    receive() {
      this.receiveTransaction({ trx_id: this.invoice_selected }).then(() => {
        this.historyUploadTermin(
          this.queryString({
            limit: this.limit,
            page: this.page,
            params: this.params,
            sort: this.sortBy,
            dir: this.sortDir,
          })
        );
      });
    },
    gotoDetail(invoice) {
      this.$router.push({
        name: "transaction-detail",
        params: { id: invoice },
      });
    },
    changePage(page) {
      this.page = page;
      this.historyUploadTermin(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir,
        })
      );
    },
  },
  created() {
    this.$store.dispatch("setPageTitle", "Transaksi");
    if(this.$route.query.code){
      this.invoiceFilter.value = this.$route.query.code
    }
    this.cari();
    // this.historyUploadTermin(
    //   this.queryString({
    //     limit: this.limit,
    //     page: this.page,
    //     params: this.params,
    //     sort: this.sortBy,
    //     dir: this.sortDir,
    //   })
    // );
  },
};
</script>
